import { request } from '@/shared/api/request'

export const getCurrentUser = (payload, params = {}) =>
	request({ url: '/user/current', method: 'POST', data: payload, params: params })
